<template lang="pug">
.embed(ref="inputText")
  slot {{text}}
</template>
<script>
import 'embed-js/dist/embed.min.css'
import EmbedJS from 'embed-js'
import basic from 'embed-preset-basic'
let Prism = require('prismjs')
import _ from 'lodash'

export default {
  props: {
    text: {
      required: false,
      default: ''
    },
    options: {
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      vEmbed: null
    }
  },
  components: {},
  created () {},
  mounted () {
    this.update()
  },
  destroyed () {
    if (this.vEmbed) {
      this.vEmbed.destroy()
    }
  },
  computed: {},
  methods: {
    update () {
      this.$nextTick(() => {
        if (this.$refs.inputText) {
          let options = _.merge({
            Prism,
            input: this.$refs.inputText,
            preset: basic({
              gAuthKey: 'AIzaSyCb5yvyrxITl3I0grfGx_OIPMCJ9MxfTFg',
              tweetsEmbed: false,
              highlightCode: true,
              linkTarget: '_blank',
              facebook: {
                height: 460
              },
              url: {
                attributes: {
                  target: '_blank'
                }
              }
            })
          }, this.options)
          this.vEmbed = new EmbedJS(options)
          this.vEmbed.render().then(() => this.$emit('done'))
        }
      })
    }
  },
  filters: {},
  watch: {
    text () {
      this.update()
    }
  }
}
</script>



// WEBPACK FOOTER //
// EmbedText.vue?5ba7d182